import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL || '',
  import.meta.env.VITE_SUPABASE_ANON_KEY || ''
);

export async function sendConsultationReminder(consultation: any) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      to: user.email,
      subject: 'Upcoming Consultation Reminder',
      content: `
        <h1>Consultation Reminder</h1>
        <p>Your ${consultation.type} consultation is scheduled in 15 minutes.</p>
        <p>Time: ${new Date(consultation.scheduled_at).toLocaleString()}</p>
        <p>Type: ${consultation.type}</p>
        <div style="margin-top: 20px;">
          <a href="${window.location.origin}/${consultation.type === 'video' ? 'video-call' : 'chat'}/${consultation.expert_id}"
             style="background-color: #2563eb; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">
            Join ${consultation.type === 'video' ? 'Video Call' : 'Chat'}
          </a>
        </div>
      `
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to send reminder');
  }
}

export function scheduleConsultationReminder(consultation: any) {
  const reminderTime = new Date(consultation.scheduled_at);
  reminderTime.setMinutes(reminderTime.getMinutes() - 15);

  const now = new Date();
  const delay = reminderTime.getTime() - now.getTime();

  if (delay > 0) {
    setTimeout(() => {
      sendConsultationReminder(consultation);
    }, delay);
  }
}